import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import CheckButton from '../CustomButtons/CheckButton'
import RadioGroup from '../CustomButtons/RadioGroup'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 80%;
  margin-top: 30px;

  @media (max-width: 763px) {
    width: 95%;
  }
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100px;
  width: 100%;
  margin-bottom: 30px;
  background-color: #F3F6F7;
  border-radius: 5px;

  @media (max-width: 763px) {
    height: 200px;
  }
`
const TitleContainer = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const ButtonsDiv = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items:center;
`
const Title = styled.span`
  padding-left: 20px;
  padding-top: 10px;
  font-size: 20px;
`

let consumable_category = []
let extra_charges = []

class Diaper extends Component {
  constructor(props) {
    super(props)
    consumable_category = this.props.consumables_categories.filter(category => category.name === 'Diapers')
    extra_charges = this.props.consumables
      .filter(charge => charge.category_id === consumable_category[0].id)

    this.state = {
      type: '',
      action: '',
      extra_charges,
    }
  }

  setInfo = (id, name) => {
    const nextState = { ...this.state }

    nextState[name] = id

    this.setState(nextState, () => this.infoToSend())
  }

  infoToSend = () => {
    this.props.setExtraData({
      category_id: this.props.category,
      type_id: this.state.type,
      contents_id: this.state.action,
      consumable_ids: this.state.extra,
    })
  }

  renderExtrasOptions = () => this.state.extra_charges.map(charge => (
    <CheckButton
      key={charge.id}
      label={charge.consumable}
      name={charge.id}
      setInfo={this.setInfo}
    />
  ))

  renderVisitOptions = () => {
    const { category, categories, child } = this.props
    const categoryIndex = category - 1

    return categories[categoryIndex].types
      .filter(type => child.uses_diapers || (!child.uses_diapers && type.name !== 'Change Needed'))
      .map(type => (
        <div
          key={type.id}
          type={type.translations.es}
          name="type"
          label={type.id}
        />
      ))
  }

  render() {
    const { extra_charges } = this.state
    return (
      <Container>
        <ButtonsContainer>
          <TitleContainer>
            <Title>Tipo</Title>
          </TitleContainer>
          <ButtonsDiv>
            <RadioGroup isRadio setInfo={this.setInfo}>
              {this.renderVisitOptions()}
            </RadioGroup>
          </ButtonsDiv>
        </ButtonsContainer>
        <ButtonsContainer>
          <TitleContainer>
            <Title>Pipí/Popó</Title>
          </TitleContainer>
          <ButtonsDiv>
            <RadioGroup isRadio setInfo={this.setInfo}>
              <div type="Pipí" name="action" label="1" />
              <div type="Popó" name="action" label="2" />
              <div type="Pipí y Popó" name="action" label="3" />
              <div type="No aplica" name="action" label="4" />
            </RadioGroup>
          </ButtonsDiv>
        </ButtonsContainer>
        { (extra_charges.length > 0)&&(  
            <ButtonsContainer>
              <TitleContainer>
                <Title>Costo Extra</Title>
              </TitleContainer>
              <ButtonsDiv>
                {this.renderExtrasOptions()}
              </ButtonsDiv>
            </ButtonsContainer>
        )}
      </Container>
    )
  }
}

Diaper.propTypes = {
  setExtraData: PropTypes.func.isRequired,
  child: PropTypes.object,
}

Diaper.defaultProps = {
  child: {},
}

const mapStateToProps = ({ consumables, consumables_categories }) => ({
  consumables: consumables.get.results,
  consumables_categories: consumables_categories.get.results,
})

const mapDispatchToProps = () => ({
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Diaper))



// WEBPACK FOOTER //
// ./src/Components/Activity/Diaper.jsx